import axios from 'axios';

export default function getCustomerWithLocations(customerId, config) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };
  // console.log(headers);
  const url = `${config.getCustomers}/${customerId}`;
  // console.log(url);
  return dispatch => dispatch({
    type: 'CUSTOMER_LOCATION_FETCH',
    payload: axios({ method: 'get', url, headers })
  }).catch((error) => {
    console.log(error);
  });
}


// WEBPACK FOOTER //
// ./src/actions/getCustomerWithLocations.js